import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PneuModel } from '@app/data/pneu/models';
import { dateFormat } from '@app/shared/formatters';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { AuthService } from '@infra/auth/auth.service';
import { DetalhesServicoExecutadoComponent } from '@modules/servicos-executados/components/detalhes-servico-executado/detalhes-servico-executado.component';
import { CustomValidators } from '@shared/validators';
import { PneusController } from '../../controllers';
import { AnexoPneuComponent } from '../../components/anexo-pneu/anexo-pneu.component';

@Component({
  selector: 'app-pneus',
  templateUrl: './pneus.component.html',
  styleUrls: ['./pneus.component.scss'],
})
export class PneusComponent extends BaseListagemComponent<PneuModel> {
  protected filtros: Campo[] = [
    {
      name: 'contrato.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '25%',
      mask: '0*',
      validators: [],
    },
    {
      name: 'veiculo.placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'veiculo.atualizacoesKm.data',
      label: 'Data Atualização KM',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [CustomValidators.data],
    },
    {
      name: 'dataAbertura',
      label: 'Data Abertura',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [CustomValidators.data],
    },
  ];

  protected acoes: Acao[] = [];

  protected colunas: Coluna[] = [
    { name: 'numeroGrupoContrato', label: 'Contrato Master' },
    { name: 'numeroOrdemServico', label: 'Nº OS' },
    { name: 'placa', label: 'Placa' },
    { name: 'modeloPneu', label: 'Modelo do Pneu' },
    { name: 'situacao', label: 'Situação' },
    { name: 'tipoItem', label: 'Tipo' },
    { name: 'kmAtual', label: 'KM Atual' },
    { name: 'dataAtualizacaoKm', label: 'Data Atualização do KM', format: dateFormat },
    { name: 'dataAbertura', label: 'Data de Abertura', format: dateFormat },
    { name: 'quantidade', label: 'Quantidade' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.verDetalhes.bind(this),
        },
        {
          label: 'Anexos',
          icon: 'attach_file',
          action: this.anexarArquivos.bind(this),
          disabled: !this.authService.hasPermission('pneus', 'EDITAR')
        },
      ],
    },
  ];

  constructor(public pneuController: PneusController, private authService: AuthService, private dialog: MatDialog) {
    super('Pneus - Portal do Cliente', pneuController);
  }

  private verDetalhes(pneu: any) {
    const ref = this.dialog.open(DetalhesServicoExecutadoComponent, {
      width: '900px',
      height: '700px',
      data: { id: pneu.codigoOrdemServico },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();
      }
    });
  }

  public anexarArquivos(pneu: any) {
    this.dialog.open(AnexoPneuComponent, {
      width: '800px',
      height: '600px',
      data: { codigoOrdemServico: pneu.codigoOrdemServico },
    });
  }
}
